import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Box, Grid, Button, Typography} from '@mui/material'
import { AddEventContext } from '../../../contexts/addEvent.context'
import ReactQuill, { Quill } from 'react-quill';
import ImageUploader from 'quill-image-uploader';
import 'react-quill/dist/quill.snow.css';

Quill.register('modules/imageUploader', ImageUploader);

const Apresentation = () => {
    const [value, setValue] = useState('');
    const quillRef = useRef();
    const {eventDTO, activeStep, setActiveStep, setEventDTO } = React.useContext(AddEventContext)

    function handleInformation() {
        setEventDTO({...eventDTO, apresentation: value})
        console.log(eventDTO)
        setActiveStep(activeStep + 1)
    }
    useEffect(()=> {
        if(eventDTO.apresentation && eventDTO.apresentation !== value){
            setValue(eventDTO.apresentation)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[eventDTO.apresentation])
    const modules = useMemo(() => ({
        toolbar: {
          container: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', "strike"],
            [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['image', "link",],
            [{ 'color': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466'] }]
          ],
          imageUploader: {
            upload: (file) => {
              console.log(file)
              return
            }
          }
        },
        clipboard: {
          matchVisual: false,
        },
        keyboard: {
          bindings: {
            tab: {
              key: 'Tab',
              handler: (range) => {
                const quill = quillRef.current?.getEditor();
                if (quill) {
                  quill.format('indent', '+1', 'user');
                }
              }
            },
            shift_tab: {
              key: 'Tab',
              shiftKey: true,
              handler: (range) => {
                const quill = quillRef.current?.getEditor();
                if (quill) {
                  quill.format('indent', '-1', 'user');
                }
              }
            },
            shift_enter: {
              key: 'Enter',
              shiftKey: true,
              handler: (range) => {
                const quill = quillRef.current?.getEditor();
                if (quill) {
                  quill.insertText(range.index, '\n', 'user');
                  quill.setSelection(range.index + 1);
                }
              }
            },
            enter: {
              key: 'Enter',
              handler: (range) => {
                const quill = quillRef.current?.getEditor();
                if (quill) {
                  quill.insertText(range.index, '\n', 'user');
                  quill.setSelection(range.index + 1);
                }
              }
            }
          }
        }
      }), [])

    return (
        <Box pb={2}>
            <Grid container spacing={2} columns={12} sx={{mb: 5}}>
              <Grid item xs={12}>
                <Typography variant='h5'>Apresentação</Typography>
              </Grid>
                <Grid item xs={12}>
                    <ReactQuill
                      ref={quillRef}
                      value={value}
                      style={{height : "450px"}}
                      modules={modules}
                      onChange={setValue}
                      theme='snow'
                      formats={[
                        'header',
                        'bold', 'italic', 'underline', 'strike',
                        'align',
                        'list', 'bullet', 'indent',
                        'link', 'image',
                        'color'
                      ]}
                      preserveWhitespace={true}
                    />
                </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                 variant="contained"
                 onClick={ () =>  setActiveStep(activeStep - 1)}
                 sx={{ mt: 3, ml: 1 }}
                 color='warning'
                 >
                  Voltar
              </Button>
                <Button
                 variant="contained"
                 onClick={() => handleInformation()}
                 sx={{ mt: 3, ml: 1 }}>
                  Próximo
                </Button>
                
            </Box>
       </Box>
    )
}
export default Apresentation;
